import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useDepartment from "@/SearchApp/composables/use-department";
import useMostSuggestedRequest from "@/SearchApp/composables/use-most-suggested-request";
import useSearch from "@/SearchApp/composables/use-search";
import type { Department } from "@ocm/global-types";
import { tr_searchDepartmentToggle } from "@/SearchApp/services/dataLayer";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleItem',
  props: {
    departmentType: {}
  },
  setup(__props: any) {

const props = __props;

const { department } = useDepartment();
const { loadSuggestions } = useMostSuggestedRequest();
const { setUpRequest, focusSearch } = useSearch();

const setDepartmentSearch = (): void => {
	department.value = props.departmentType;
	loadSuggestions();
	setUpRequest();
	focusSearch();
	tr_searchDepartmentToggle({ action: "department-switch", label: props.departmentType, searchterm: undefined });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["flex items-center border-b-2 supportsHover:hover:border-b-current supportsHover:hover:text-black-primary", _unref(department) === _ctx.departmentType ? 'text-black-primary' : 'border-b-transparent'])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "h-full px-4 focus:-outline-offset-2",
      onClick: setDepartmentSearch
    }, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})